module.exports = __webpack_public_path__ + "static/media/photo.b2eac7a6.bin";